<template>
  <b-row>
    <b-col md="12">
      <select2
          :model.sync="incomingInvoice.workFlo"
          name="workFlo"
          :options="autocompleteWorkFlos"
      />
    </b-col>
  </b-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import Select2 from '../../../input/Select2.vue'
import useAPI from '../../../../utils/useAPI'

export default {
  components: {
    Select2
  },
  props: {
    incomingInvoice: {
      type: Object,
      default: () => {}
    },
  },
  setup () {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { autocompleteWorkFlos } = useAPI()

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed
      autocompleteWorkFlos,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style
    scoped
    lang="scss"
>

</style>